import { MutationOptions, QueryObserverOptions, QueryOptions, UseMutateFunction, useMutation, UseMutationResult, useQuery, UseQueryResult } from "@tanstack/react-query";
import { APIClient } from './types';

export interface IApiResponse<T> {
	query: UseQueryResult<T, unknown>;
	data: T;
	loading: boolean;
}

export interface IMutationResponse<TRes> {
	mutate: any;
	loading: boolean;
}

export class ApiBase {
    constructor(readonly client: APIClient, readonly loggedInUser: string, readonly servicePath: string) {}

	private getFullPath = (queryKey: string) => `${this.servicePath}/${queryKey}`;

	async post<TReq, TRes>(queryKey: string, req: TReq): Promise<TRes> {
		let fullPath = this.getFullPath(queryKey);
		const response = await this.client.post<any, any>(fullPath, req);
		if (response.data.res.success) { 
			return response.data.res.data;
		}
		throw new Error(response.data.res.data);
	}

    callAuthenticated<TReq, TRes>(queryKey: string, req: TReq, options?: QueryObserverOptions<TRes>): IApiResponse<TRes> {
		let fullPath = this.getFullPath(queryKey);
		const query = useQuery<TRes>(
			[fullPath, req, this.loggedInUser], // req.toString() is used to prevent caching??
			async () =>  this.post<TReq, TRes>(queryKey, req),
			options
		);
        return {
            query: query,
            data: query.data,
            loading: query.isLoading
        };
    }

	mutateAuthenticated<TReq, TRes>(queryKey: string, req: TReq, options?: MutationOptions<TRes>): IMutationResponse<TRes> {
		let fullPath = this.getFullPath(queryKey);
		const { mutate, isLoading } = useMutation({
			mutationKey: [fullPath, req, this.loggedInUser],
			mutationFn: async () => this.post<TReq, TRes>(queryKey, req),
			...options
		});
		return {
			mutate,
			loading: isLoading
		};
	}
}
